import React, { useEffect, useMemo, useState } from 'react'
import { Card, CardBody, CardHeader, Col, Container, Row, Spinner, Label, Input, Button } from 'reactstrap'
import TableContainer from '../../Components/Common/TableContainerReactTable';
import useObtenerCoMaedcvPorTenant from '../../Components/Hooks/useObtenerCoMaedcvPorTenant';
import useCreateCoMaedcv from '../../Components/Hooks/useCreateCoMaedcv';
import ModalCrearCoMaedcv from '../../Components/modals/ModalCrearCoMaedcv';
import ModalLeerCoMaedcv from '../../Components/modals/ModalLeerCoMaedcv';
import ModalModificarCoMaedcv from '../../Components/modals/ModalModificarCoMaedcv';

const MaestroDCV = () => {

    const [limit, setLimit] = useState(100);
    const [selectedRecord, setSelectedRecord] = useState('');
    const [refresh, setRefresh] = useState(0);
    const { coMaedcv, loading, error } = useObtenerCoMaedcvPorTenant(limit, refresh);
    const [modalCrearOpen, setModalCrearOpen] = useState(false);
    const [modalLeerOpen, setModalLeerOpen] = useState(false);
    const [modalModificarOpen, setModalModificarOpen] = useState(false);
    const { createCoMaedcv, loading: createLoading, error: createError } = useCreateCoMaedcv();

    useEffect(() => {
        document.title = "Maestro DCV | Siga ERP";
    }, []);

    const columns = useMemo(
        () => [
            {
                header: "Tipo Folio",
                accessorKey: "TIPFOL",
                enableColumnFilter: false,
            },
            {
                header: "Número Folio",
                accessorKey: "NUMFOL",
                enableColumnFilter: false,
            },
            {
                header: "Tipo Documento",
                accessorKey: "TIPDOC",
                enableColumnFilter: false,
            },
            {
                header: "Número Documento",
                accessorKey: "NUMDOC",
                enableColumnFilter: false,
            },
            {
                header: "Fecha Documento",
                accessorKey: "FECDOC",
                enableColumnFilter: false,
                cell: (info) => info.getValue() ? new Date(info.getValue()).toLocaleDateString() : '',
            },
            {
                header: "Valor Total",
                accessorKey: "VALTOT",
                enableColumnFilter: false,
                cell: (info) => info.getValue() ? parseFloat(info.getValue()).toLocaleString() : '',
            },
            {
                header: "Estado",
                accessorKey: "ESTADO",
                enableColumnFilter: false,
            },
        ],
        []
    );

    const handleCellClick = (cellInfo) => {
        console.log('Celda clickeada:', cellInfo);
        console.log('Columna:', cellInfo.columnId);
        console.log('Valor:', cellInfo.value);
        console.log('Datos completos de la fila:', cellInfo.rowData);
        setSelectedRecord(`${cellInfo.rowData.CLAEMP}-${cellInfo.rowData.TIPFOL}-${cellInfo.rowData.NUMFOL}`);
    }

    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <Row>
                        <Col lg={12}>
                            <Card>
                                <CardHeader className="d-flex justify-content-between align-items-center">
                                    <h5 className="card-title mb-0">Maestro DCV</h5>
                                    <div className="mt-0">
                                        <Input
                                            type="text"
                                            value={selectedRecord}
                                            onChange={(e) => setSelectedRecord(e.target.value)}
                                            style={{ width: '300px' }}
                                        />
                                    </div>
                                    <div className="d-flex align-items-center">
                                        <Button color="info" className="me-2" onClick={() => { if (selectedRecord) setModalLeerOpen(true); }} disabled={!selectedRecord}>
                                            <i className="ri-eye-line me-1"></i>Leer
                                        </Button>
                                        <Button color="warning" className="me-2" onClick={() => { if (selectedRecord) setModalModificarOpen(true) }} disabled={!selectedRecord}>
                                            <i className="ri-edit-line me-1"></i>Modificar
                                        </Button>
                                        <Button color="primary" className="me-2" onClick={() => setModalCrearOpen(true)} disabled={createLoading}>
                                            <i className="ri-add-line me-1"></i>Crear
                                        </Button>
                                        <Label className="form-label mb-0 me-2">Límite</Label>
                                        <div className="mt-0">
                                            <Input
                                                type="number"
                                                min={1}
                                                value={limit}
                                                onChange={(e) => setLimit(e.target.value)}
                                                style={{ width: '100px' }}
                                            />
                                        </div>
                                    </div>
                                </CardHeader>
                                <CardBody>
                                    {error ? <div className="alert alert-danger">{error}</div> : loading ? <div className="text-center"><Spinner animation="border" variant="primary" /></div> : <TableContainer
                                        columns={(columns || [])}
                                        data={coMaedcv || []}
                                        customPageSize={15}
                                        isGlobalFilter={true}
                                        SearchPlaceholder='Buscar...'
                                        onCellClick={handleCellClick}
                                    />}
                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </Container>
            </div>
            <ModalCrearCoMaedcv
                isOpen={modalCrearOpen}
                toggle={() => setModalCrearOpen(false)}
                onSave={async (formData) => {
                    const result = await createCoMaedcv(formData);
                    console.log('Resultado de la creación del registro CO_MAEDCV:', result);
                    if (result.success) {
                        alert('Registro CO_MAEDCV creado exitosamente');
                        setModalCrearOpen(false);
                        setRefresh(prev => prev + 1); // Refresh the table
                    } else {
                        alert('Error al crear registro CO_MAEDCV: ' + result.error);
                    }
                }}
            />
            <ModalLeerCoMaedcv
                isOpen={modalLeerOpen}
                toggle={() => setModalLeerOpen(false)}
                selectedRecord={selectedRecord}
            />
            <ModalModificarCoMaedcv
                isOpen={modalModificarOpen}
                toggle={() => setModalModificarOpen(false)}
                onSave={() => {
                    setRefresh(prev => prev + 1); // Refresh the table
                }}
                selectedRecord={selectedRecord}
            />
        </React.Fragment>
    )
}

export default MaestroDCV;